import { AppIcon } from '@tablesready/frontend-icons';

export interface NavigationItem {
  href: string;
  name: string;
  icon: AppIcon;
  pattern?: string;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    href: '/waitlist',
    name: 'Waitlist',
    icon: AppIcon.waitlist,
  },
  {
    href: '/reservations',
    name: 'Reservations',
    icon: AppIcon.reservations,
  },
  {
    href: '/floorplan',
    name: 'Floor Plan',
    icon: AppIcon.floorPlan,
  },
  {
    href: '/togo',
    name: 'To Go',
    icon: AppIcon.togo,
  },
  {
    href: '/history',
    name: 'Recent',
    icon: AppIcon.recent,
  },
  {
    href: '/analytics',
    name: 'Analytics',
    icon: AppIcon.analytics,
  },
  {
    href: '/customers',
    name: 'Customers',
    icon: AppIcon.customers,
  },
  {
    href: '/settings/preferences/notifications',
    name: 'Settings',
    icon: AppIcon.settings,
    pattern: '/settings',
  },
  {
    href: '/admin',
    name: 'Admin',
    icon: AppIcon.admin,
  },
];
